/* eslint-disable */
///-------------------------------------------------------------------------------------------------
// summary:	General Services
///-------------------------------------------------------------------------------------------------

import Api from './Api';

export default {

  getCategories() {
//    const response = Api().get(`/api/1/itemCategories/catering`);  // get all the "catering" item categories;
    const response = Api().get(`/api/1/itemCategories/pos`);  // get all the "pos" item categories;
    return response;
  },
  getItems(category) {
    const response = Api().get(`/api/1/items/${category}`);  // Get the items in this category
    return response;
  },

  getEventTypes() {
    const response = Api().get(`/api/1/catering/eventTypes`);  // Get the types of catering events we can offer; this returns a list of itemTypes for each catering event type
    return response;
  },
  addOrder(order) {
    const response = Api().post('/api/1/catering/order', order);
    return response;
  },
  getOrder(orderId) { // get a specific catering order; can pass the _id OR the catering order number
    const response = Api().get(`/api/1/catering/order/${orderId}`);
    return response;
  },
  getOrders() { // gets currently open catering order listing
    const response = Api().get(`/api/1/catering/orders`);
    return response;
  },
  updateOrder(order) {
    const response = Api().patch('/api/1/catering/order', order);
    return response;
  },
  removeOrder(orderId) {
    const response = Api().delete(`/api/1/catering/order/${orderId}`);
    return response;
  },
  // Get the open catering orders for the specified account
  ordersByAccount( accountNumber ) {
    const response = Api().get(`/api/1/catering/ordersByAccount/:accountNumber/${accountNumber}`);
    return response;
  }

}
